<template>
	<div class="flex_jc" style="position: relative; min-height: 100vh; background-color: #f2f2f2">
		<!-- 密码重置 -->
		<div class="box_login box_login1" style="margin: 30px 0">
			<div class="flex_jc">
				<div class="div_pwp">{{$t('resetpwd.title')}}</div>
			</div>
			<el-form :model="resetForm" :rules="reset_rules" ref="resetForm" label-position="top" label-width="80px"
				class="demo-resetForm">
				<el-form-item :label="$t('resetpwd.email_title')" prop="email" style="margin-bottom: 0px">
					<el-input v-model="resetForm.email" :placeholder="$t('resetpwd.email_placeholder')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('resetpwd.code_title')" prop="code" style="margin-bottom: 0px">
					<el-input v-model="resetForm.code" :placeholder="$t('resetpwd.code_placeholder')">
						<template #append>
							<el-button type="primary" @click="sendCode"
								style="background-color: #4679f0; color: #fff">{{$t('resetpwd.get_code_button_title')}}</el-button>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('resetpwd.pwd_title')" prop="pwd" style="margin-bottom: 0px">
					<el-input v-model="resetForm.pwd" :placeholder="$t('resetpwd.pwd_placeholder')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('resetpwd.confirm_pwd_title')" prop="confirm_pwd" style="margin-bottom: 0px">
					<el-input v-model="resetForm.confirm_pwd"
						:placeholder="$t('resetpwd.confirm_pwd_placeholder')"></el-input>
				</el-form-item>
			</el-form>
			<div class="flex_jc top_up">
				<el-button type="primary" round style="width: 300px" @click="submitForm('resetForm')">{{$t('resetpwd.submit_button_title')}}</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getCode,
		resetPwd
	} from '@/api/login';
	export default {
		name: "FindPage",
		data() {
			return {
				login_type: 1,
				input: '',
				is_login: true,
				resetForm: {
					email: '',
					code: '',
					pwd: '',
					confirm_pwd: '',
				},
				reset_rules: {
					email: [{
						required: true,
						message: '',
						trigger: "blur"
					}],
					code: [{
						required: true,
						message: '',
						trigger: "blur"
					}],
					pwd: [{
						required: true,
						message: '',
						trigger: "blur"
					}],
					confirm_pwd: [{
						required: true,
						message: '',
						trigger: "blur"
					}],
				},
			};
		},
		created() {
			// console.log('create',this.reset_rules.email[0].message)
			this.reset_rules.email[0].message = this.$t('resetpwd.email_rule')
			this.reset_rules.code[0].message = this.$t('resetpwd.code_rule')
			this.reset_rules.pwd[0].message = this.$t('resetpwd.pwd_rule')
			this.reset_rules.confirm_pwd[0].message = this.$t('resetpwd.confirm_pwd_rule')
		},
		methods: {
			sendCode() {
				console.log('eee', this.resetForm)
				if (this.resetForm.email == '') {
					this.$modal.msgError(this.$t('register.email_tip'))
					return
				}
				getCode({
					email: this.resetForm.email,
					type: 2
				}).then(res => {
					if (res.code == 200) {
						this.$modal.msgSuccess(res.msg)
					} else {
						this.$modal.msgError(res.msg)
					}
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						resetPwd(this.resetForm).then(res => {
							if (res.code == 200) {
								this.$modal.msgSuccess(res.msg)
							} else {
								this.$modal.msgError(res.msg)
							}
						})
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			reset(formName) {
				this.$refs[formName].resetFields();
			},
		},
	};
</script>

<style>
	.el-form--label-top .el-form-item__label {
		padding: 0 !important;
	}

	@media (max-width: 768px) {
		.div_pwp {
			min-width: 80px !important;
			font-size: 20px !important;
			text-align: center;
			font-weight: bold;
			margin-bottom: 30px;
			border-bottom: 5px solid #4679f0;
		}

		.box_login {
			width: 80% !important;
			background-color: #fff;
			border-radius: 20px;
			padding: 30px;
			padding: 30px;
			position: absolute;
			top: 40%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.box_login1 {
			width: 80% !important;
		}
	}

	.div_pwp {
		min-width: 115px;
		font-size: 28px;
		text-align: center;
		font-weight: bold;
		margin-bottom: 30px;
		border-bottom: 5px solid #4679f0;
	}

	.box_login {
		width: 25%;
		background-color: #fff;
		border-radius: 20px;
		padding: 30px;
		padding: 30px;
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
</style>